import React, { useEffect, useState } from "react";
import {UpdateTargets} from "./UpdateTargets";
import {CountryRebalance} from './CountryRebalance'
import {FundTransfer} from './FundTransfer'
import { FundRebalance } from './FundRebalance'

export const Rebalance = () => {
  const [selectRadioBtn, setSelectRadioBtn] = useState<any>("option1");

  useEffect(() => {
  }, [selectRadioBtn]);

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Rebalance</h1>
      </div>
      <div className="row w-100 card p-4">
        <div>
          <label className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value="option1"
              name="radios-example"
              onClick={(e: any) => setSelectRadioBtn(e.target.value)}
              defaultChecked
            />
            <span className="form-check-label">Update Targets</span>
          </label>
          <label className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value="option2"
              name="radios-example"
              onClick={(e: any) => setSelectRadioBtn(e.target.value)}
            />
            <span className="form-check-label">Fund Transfer</span>
          </label>
          <label className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value="option3"
              name="radios-example"
              onClick={(e: any) => setSelectRadioBtn(e.target.value)}
            />
            <span className="form-check-label">Rebalance</span>
          </label>
        </div>
        {selectRadioBtn && selectRadioBtn === "option1" ? (
          <UpdateTargets />
        ) : null}
        {selectRadioBtn && selectRadioBtn === "option2" ? (
          <FundTransfer />
        ) : null}
        {selectRadioBtn && selectRadioBtn === "option3" ? (
          <FundRebalance />
        ) : null}
        {selectRadioBtn && selectRadioBtn === "option4" ? (
          <CountryRebalance />
        ) : null}
      </div>
    </div>
  );
};
